import {LoginFormKeyEnum, LoginFormType} from '../../../service/user/user-login';

export const initialValues: LoginFormType = {
    [LoginFormKeyEnum.Email]: '',
    [LoginFormKeyEnum.Password]: '',
    [LoginFormKeyEnum.RememberMe]: false,
};
